export default function About() {
  return (
    <section data-testid="about-section" className="border-b border-white/10 py-10 md:py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="reveal max-w-5xl">
          <p className="font-cormorant italic text-3xl md:text-5xl leading-[1.15] text-white">
            We are{" "}
            <span className="font-oswald not-italic uppercase font-bold text-white bg-[#00A0E4] text-[#000000] px-2">
              dotMKV Media
            </span>{" "}
            — a post-production agency specializing in high-quality editing for reaction videos,
            podcasts, and digital content.
          </p>
          <p className="mt-8 font-manrope text-base md:text-lg text-white/65 max-w-3xl leading-relaxed">
            We work with global creators and brands, delivering clean, engaging, platform-ready edits
            with fast turnaround, modern workflows, and a strong understanding of online trends to help
            clients stand out across all platforms.
          </p>
        </div>
      </div>
    </section>
  );
}
